import { createUploadLink } from "apollo-upload-client";

import { BUILD_TYPE } from "../../shared/constants";
import { Services, urlMap } from "../../shared/infrastructure";

export const apiLink = createUploadLink({
    uri: urlMap[Services.INSIGHTS_LENS_STUDIO_WEB][BUILD_TYPE],
    credentials: "same-origin",
});
